import { Routes } from '../hooks/anas-router/routes';

export const ERROR_MESSAGES = {
  generic: 'Oops something went wrong!',
  update: 'Unable to update data!',
  get: 'Unable to get data!',
  reschedule: 'Unable to reschedule!',
  call: 'Unable to initiate call!',
  location: 'Location is non-serviceable',
};

export const CONSULTATION_CODE_DEFAULT = 'SC';

export const CONSULTATION_NAME_DEFAULT = 'Screening Call';

export const ONLINE_LOCATION_ID = process.env.ONLINE_LOCATION_ID;

export const PRACTO_LOCATION_ID = process.env.PRACTO_LOCATION_ID;

export const embeddedRoutes = ['login', 'authorize'];

export const defaultBookingAmount = 199;

export const smallScreenWidth = 768;

export const reportTypes = {
  PRESCRIPTION: 'prescription',
  ASSESSMENT: 'assessment',
  SCREENING: 'screening',
};

export const getReportData = (reportType: string = reportTypes.ASSESSMENT) => {
  return {
    subHeader: 'Your expected diagnosis came out to be',
    diagnosisHeader: '',
    validDisclaimer: 'Sexual disorders are common & treatable. More than 87% saw improvement with Allo in 6-8 weeks',
    invalidDisclaimer: '',
  };
};

export const likelinessData = {
  'Highly Likely': {
    likeliness: 'Highly Likely',
    subheader: 'High likelihood of diagnosis',
    description: 'This state means that you have major symptoms of the respective disorder.',
    image: 'likeliness-high.png',
  },
  'Less Likely': {
    likeliness: 'Less Likely',
    subheader: 'Less likely of diagnosis',
    description: 'Less likely state means that you have some symptoms of the certain disorder.',
    image: 'likeliness-less.png',
  },
  Likely: {
    likeliness: 'Likely',
    subheader: 'Diagnosis is likely',
    description: 'Likely state means that you have some symptoms of the certain disorder.',
    image: 'likeliness-less.png',
  },
  Unlikely: {
    likeliness: 'Unlikely',
    subheader: 'diagnosis Unlikely',
    description: 'Unlikely state means that you don’t have the symptoms of any disorder.',
    image: 'likeliness-none.png',
  },
};

export const rootCauseList = [
  {
    id: 1,
    title: 'Lifestyle',
    image: 'lifestyle',
    description:
      'Unhealthy lifestyles significantly affect sexual health. Appropriate blood flow is needed for an erection, and conditions such as cardiovascular disease, obesity, hypertension, and diabetes negatively impacts blood flow. Lack of physical activity and a poor diet can lead to the above conditions, which can cause erectile dysfunction.',
  },
  {
    id: 2,
    title: 'Smoking',
    image: 'smoking',
    description:
      'Smoking negatively impacts heart and blood vessel health—both significantly impact erectile function. It lowers testosterone levels, increases carbon monoxide levels, which reduce testosterone production, leading to a lower libido. Smokers, regardless of age or other factors, have an increased risk of developing ED. ',
  },
  {
    id: 3,
    title: 'Drinking',
    image: 'drinking',
    description:
      'Alcohol is a nervous system depressant; it affects respiration, nerve sensitivity, and circulation. It can lead to dehydration and decreased levels of testosterone, a crucial hormone, impacting blood and oxygen flow and causing blood vessels to dilate. Its consumption can also lead concerns such as depression and stress.',
  },
  {
    id: 4,
    title: 'Physical Health',
    image: 'physical-health',
    description:
      'There are chronic medical conditions that can negatively impact sexual health - these conditions include diabetes, obesity, hypertension, stress, depression etc. Untreated medical conditions can lead to sexual dysfunction, especially conditions such as ED and PE.',
  },
  {
    id: 5,
    title: 'Emotional Health',
    image: 'psychological',
    description:
      'Sexual and mental health are more directly linked than you think - the mind and body work together for sex to be pleasurable.Depression or anxiety can lead to sexual dysfunctions such as low sexual desire and ED and symptoms such as performance anxiety. Psychological counselling is, if prescribed, a critical and rewarding part of treatment.',
  },
  {
    id: 6,
    title: 'Relationship',
    image: 'relationship',
    description:
      'Interpersonal concerns indicates an individual may be going through a hard time with someone they care for.For example, emotional or physical concerns within a relationship can deeply affect the couple(s) sexual intimacy. This can lead to ED, PE, Vaginismus and low sexual desire.Treating these concerns equip individuals with tools to understand triggers.',
  },
];

export const contentsOffers = [
  {
    id: 1,
    title: 'Medications',
    image: 'medications',
    description:
      'Delivery of prescribed medicines to your doorstep at no additional cost in a package with no branding or name.',
  },
  {
    id: 2,
    title: 'Counselling',
    image: 'counselling',
    description:
      'Our professionals are specifically trained to create a safe space for you to address you concerns & share your inhibitions',
  },
  {
    id: 3,
    title: 'Nutrition',
    image: 'nutrition',
    description:
      'Healthy nutrition recommendations & suggestions to sustain the overall wellbeing & support other targeted treatment',
  },
  {
    id: 4,
    title: 'Exercise',
    image: 'exercise',
    description:
      'We conduct a holistic assessment of your concerns and suggest specific exercises that can help you achieve your sexual health goals',
  },
  {
    id: 5,
    title: 'Lifestyle',
    image: 'lifestyle-white',
    description:
      'Often times a small change in lifestyle goes a long way. Our experts will recommend some effective changes in your existing lifestyle to achieve sustainable improvements. ',
  },
  {
    id: 6,
    title: 'Education',
    image: 'education',
    description:
      '100% science backed resources for you to learn more about your issue, and overcome minor triggers in daily-life that amplify them.',
  },
  {
    id: 7,
    title: 'Support',
    image: 'support',
    description:
      'Our team of in-house care experts are trained to suggest protocol based suggestions for your concerns, and act as a single point of contact for an effective and discreet care.',
  },
];

export const whatsappContactLink = 'https://wa.me/+918618365103?text=';

export const SexpertAILink = 'https://www.allohealth.care/sexpertai';

export const whyTakeAssessmentVideo = 'https://www.youtube.com/embed/msRnkOv3uAA';

export const whoIsAlloVideoLink = 'https://www.youtube.com/embed/CC-jg5NtVcE';

export const testimonials = [
  {
    title: 'Discreet & timely delivery of medicines was an added bonus!',
    age: 28,
    gender: 'male',
    martialStatus: 'Unmarried',
    description:
      'I was very nervous about receiving any medications, but Allo delivered them discreetly. I was very grateful for this and was able to afford my medications with their discount. The medications were delivered within 2 days and I was able to begin following my Treatment Plan quickly',
  },
  {
    title: 'Embarrassed about Premature Ejaculation',
    age: 25,
    gender: 'male',
    martialStatus: 'In relationship',
    description:
      'I was suffering from premature ejaculation for quite some time, and decided to sign up with Allo Health. I was very uncomfortable and embarrassed in talking about it at first, but quickly felt safe because of how the process was explained to me in detail. I am happy to say that the treatment worked great for both me and my partner. Huge thanks to their care team for getting me through!',
  },
];

export enum LOCALE {
  'ENGLISH' = 'en',
  'HINDI' = 'hi',
}

export enum LANGUAGE {
  'ENGLISH' = 'English',
  'HINDI' = 'हिंदी',
}

export const blogData = [
  {
    title: 'How diet can help with ED?',
    description:
      'There are foods that improve erectile dysfunction by aiding in improved blood flow, increased testosterone......',
    image: 'allo-diet-blog.png',
    link: `/healthfeed/erectile-dysfunction/foods-and-diet-for-erectile-dysfunction`,
  },
  {
    title: 'Myths & Facts About Infertility',
    description:
      'Are you curious about infertility? Discover the truth by exploring these 5 essential Infertility facts and myths problems, provided by Allo Health.',
    image: 'allo-ed-pe-blog.png',
    link: `/healthfeed/infertility/infertility-facts-and-myths`,
  },
];

export const timePeriods = {
  'All Slots': {
    start: 7,
    end: 23,
  },
  Morning: {
    start: 7,
    end: 13,
  },
  Afternoon: {
    start: 13,
    end: 17,
  },
  Evening: {
    start: 17,
    end: 23,
  },
};

export const adviceTypes = {
  provider_advice: 'General Advice',
  provider_advice_pe: 'Advice on Premature Ejaculation',
  provider_advice_ed: 'Advice on Erectile Dysfunction',
  provider_advice_porn_addiction: 'Advice on Porn Addiction',
  provider_advice_compulsive_masturbation: 'Advice on Compulsive Masturbation',
  provider_advice_de: 'Advice on Delayed Ejaculation',
  provider_advice_low_desire: 'Advice on Low Sexual Desire',
  provider_advice_vaginismus: 'Advice on Vaginismus',
  provider_advice_fsad: 'Advice on Female Sexual Arousal Disorder',
  provider_advice_other: 'Other advice',
  provider_advice_sti: 'Advice on Sexually Transmitted Infections',
};

export const appointmentTypes = {
  CONSULTATION: 'Consultation',
  SCREENING_CALL: 'Screening Call',
  FIRST_CONSULTATION: 'First Consultation',
  FOLLOW_UP: 'Follow Up',
  OFFLINE: 'Offline',
  THERAPY: 'Therapy',
  RECONSULTATION: 'Reconsultation',
  RESCHEDULE: 'Reschedule',
  OFFLINE_THERAPY: 'Offline Therapy',
  REPORT_READING: 'Report Reading',
};

export const RESCHEDULE_REASON = 'Patient rescheduled via Confirmation page';

export const rxTypes = {
  SCREENING_RX: 'screening-rx',
  CONSULTATION_RX: 'consultation-rx',
  CAMPAIGN_CALL_RX: 'campaign-call-rx',
  MERGE_RX: 'merged-rx',
  TAKE_AX: 'take-ax',
  COUNSELLING_RX: 'counselling-rx',
  SCREENING_AX: 'screening-ax',
};

export const metaDataTypes = {
  PRECAUTION: 'precautions',
  SIDE_EFFECT: 'side_effects',
  USE: 'use',
  FAQ: 'faq',
  EFFECT: 'effects',
  BASIC_INFO: 'basic_info',
};

export const metaDataSequence = {
  [metaDataTypes.BASIC_INFO]: 1,
  [metaDataTypes.USE]: 2,
  [metaDataTypes.PRECAUTION]: 3,
  [metaDataTypes.EFFECT]: 4,
  [metaDataTypes.SIDE_EFFECT]: 5,
  [metaDataTypes.FAQ]: 6,
};

export const COUNSELLING_CUSTOM_KEYS = {
  COUNSELLING_GOALS_DICTIONARY: 'counselling_goals_dictionary',
};

export const formFeatures = [
  {
    feature: 'Best use of time',
    icon: 'stopwatch.svg',
  },
  {
    feature: '100% confidential',
    icon: 'security-checked.svg',
  },
  {
    feature: 'More holistic expert discussion',
    icon: 'user-music.svg',
  },
  {
    feature: 'No stressing about important details',
    icon: 'info-cloud.svg',
  },
];

export const bannerTypes = {
  TP: 'TP',
  SC: 'SC',
};

//order matters
export const PAGE = {
  DASHBOARD: {
    NAME: 'DASHBOARD',
    ROUTE: 'dashboard',
  },
  FEEDBACK: {
    NAME: 'FEEDBACK',
    ROUTE: 'feedback',
  },
  APPOINTMENTS: {
    NAME: 'APPOINTMENTS',
    ROUTE: 'appointments',
  },
  APPOINTMENT: {
    NAME: 'APPOINTMENT',
    ROUTE: 'appointment',
  },
  CONFIRMATION: {
    NAME: 'CONFIRMATION',
    ROUTE: 'confirmation',
  },
  ASSESSMENT_REPORT: {
    NAME: 'ASSESSMENT_REPORT',
    ROUTE: 'assessment-report',
  },
  ASSESSMENT: {
    NAME: 'ASSESSMENT',
    ROUTE: 'assessment',
  },
  LATEST_RECORD: {
    NAME: 'LATEST_RECORD',
    ROUTE: 'records/latest',
  },
  RECORDS: {
    NAME: 'RECORDS',
    ROUTE: 'records',
  },
  PURCHASE: {
    NAME: 'PURCHASE',
    ROUTE: 'purchase',
  },
  LOGIN: {
    NAME: 'LOGIN',
    ROUTE: 'login',
  },
  LOGOUT: {
    NAME: 'LOGOUT',
    ROUTE: 'logout',
  },
  HMS: {
    NAME: 'HMS',
    ROUTE: 'meet',
  },
  REDIRECT: {
    NAME: 'REDIRECT',
    ROUTE: 'redirect',
  },
  RESOURCES: {
    NAME: 'RESOURCES',
    ROUTE: 'resources',
  },
  AUTHORIZE: {
    NAME: 'AUTHORIZE',
    ROUTE: 'authorize',
  },
  PREPORT: {
    NAME: 'PREPORT',
    ROUTE: 'prescription-report',
  },
  REPORT: {
    NAME: 'REPORT',
    ROUTE: 'report',
  },
  PRINT_PRESCRIPTION: {
    NAME: 'PRINT_PRESCRIPTION',
    ROUTE: 'print-prescription',
  },
  PROFILE: {
    NAME: 'PROFILE',
    ROUTE: 'profile',
  },
  MEDICINES: {
    NAME: 'MEDICINES',
    ROUTE: 'medicines',
  },
  LAB_TESTS: {
    NAME: 'LAB_TESTS',
    ROUTE: 'lab-tests',
  },
};

export const TRANSITION_PAGES = [PAGE.LOGIN, PAGE.LOGOUT, PAGE.AUTHORIZE, PAGE.REDIRECT];

export const ROUTE_NAVIGATION = {
  DASHBOARD: {
    name: 'Dashboard',
    route: Routes.DASHBOARD,
    activeIcon: 'home-purple.svg',
    inactiveIcon: 'home.svg',
    icon: 'home',
  },
  PREPORT: {
    name: 'Prescription',
    route: Routes.PREPORT,
    activeIcon: 'document-purple.svg',
    inactiveIcon: 'document.svg',
  },
  RECORDS: {
    name: 'My Records',
    route: Routes.RECORDS,
    activeIcon: 'record-purple.svg',
    inactiveIcon: 'record.svg',
  },
  APPOINTMENT: {
    name: 'Appointments',
    route: Routes.APPOINTMENTS,
    icon: 'stethoscope',
  },
  MEDICINES: {
    name: 'Medicines',
    route: Routes.MEDICINES,
    icon: 'medication',
  },
  LAB_TESTS: {
    name: 'Lab Tests',
    route: Routes.LAB_TESTS,
    icon: 'Labs',
  },
  REPORT: {
    name: 'Report',
    route: Routes.RECORDS,
    icon: 'lab_profile',
  },
};

export const alloPhoneNumber = '+918071175797';
export const alloWhatsAppNumber = '+918618365103';
export const alloInstagramHandle = '@allohealth.care';

export const LanguageTranslations = {
  bangla: 'বাংলা',
  bengali: 'বাংলা',
  gujrati: 'ગુજરાતી',
  gujarati: 'ગુજરાતી',
  hindi: 'हिंदी',
  kannada: 'ಕನ್ನಡ',
  malayalam: 'മലയാളം',
  marathi: 'मराठी',
  punjabi: 'ਪੰਜਾਬੀ',
  tamil: 'தமிழ்',
  telugu: 'తెలుగు',
  english: 'English',
  french: 'Français',
  spanish: 'Español',
  german: 'Deutsch',
  italian: 'Italiano',
  portuguese: 'Português',
  russian: 'русский',
  chinese: '中文',
  japanese: '日本語',
  korean: '한국어',
  arabic: 'العربية',
  turkish: 'Türkçe',
  thai: 'ไทย',
  indonesian: 'Bahasa Indonesia',
  vietnamese: 'Tiếng Việt',
  polish: 'Polskie',
  dutch: 'Nederlands',
  swedish: 'Svenska',
  norwegian: 'Norsk',
  finnish: 'Suomalainen',
  danish: 'Dansk',
  czech: 'Český',
  hungarian: 'Magyar',
  konkani: 'कोंकणी',
};

export const CONSULTATION_TYPE = {
  FU: 'FU',
  SC: 'SC',
  FC: 'FC',
  TH: 'TH',
  PQ: 'PQ',
  RR: 'RR',
};

export const CONSULTATION_STATE = {
  RESCHEDULE: 'reschedule',
  SCHEDULE: 'schedule',
  RECONSULT: 'reconsult',
  CANCEL: 'cancel',
};

export enum ConsultationMode {
  Instant = 'instant',
  Walkin = 'walkin',
  InClinic = 'in_clinic',
  Online = 'online',
  Practo = 'practo',
}

export enum UserRole {
  PATIENT = 'patient',
  PROVIDER = 'provider',
  AGENT = 'agent',
  SUPERADMIN = 'superadmin',
}

export const DEFAULT_CITY = 'Bangalore';

export enum frequencyValues {
  daily = 'daily',
  ondemand = 'as needed',
  dual = 'alternate day',
  onceAWeek = 'once a week',
  onceInThreeDays = 'once in 3 days',
}

export enum CONSULTATION_NAMES {
  FU = 'Follow Up',
  SC = 'Screening Call',
  FC = 'First Consultation',
  TH = 'Therapy',
  PQ = 'Patient Queries',
  RR = 'Report Reading',
}

export enum WeekDays {
  Sunday,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
}

export const WHAT_TO_AVOID = [
  {
    icon: '/assets/svgs/drug-cancel.svg',
    title: 'what-to-avoid.self-medication',
  },
  {
    icon: '/assets/svgs/seeking-frame.svg',
    title: 'what-to-avoid.delay-in-seeking-help',
  },
  {
    icon: '/assets/svgs/suppliment-cancel.svg',
    title: 'what-to-avoid.unverified-supplements',
  },
];

export const REVIEWS = [
  {
    icon: '/assets/practo.png',
    title: 'Practo',
    rating: 4.9,
    svg: '/assets/svgs/star.svg',
  },
  {
    icon: '/assets/google.png',
    title: 'Google',
    rating: 4.7,
    svg: '/assets/svgs/star.svg',
  },
];

export const ELLIPSE_REVIEWS = [
  {
    icon: '/assets/star-ellipse.png',
    title: 'star',
    rating: '4.7/5',
    description: ' ellipse-reviews.average-consultation-ratings-with-allo', //translatory
  },
  {
    icon: '/assets/cross-ellipse.png',
    title: 'cross',
    rating: '87%',
    description: ' ellipse-reviews.users-saw-significant-improvements', //translatory
  },
];

export const TRACK_ORDERS = [
  {
    title: 'left-view',
    icon: '/assets/track-phone-left.png',
  },
  {
    title: 'middle-view',
    icon: '/assets/track-phone-middle.png',
  },
  {
    title: 'right-view',
    icon: '/assets/track-phone-right.png',
  },
];

export const APPOINTMENT_BLOCKER_MESSAGE = [
  'Reliable Medical Advice',
  'Convenient, Confidential Consultation',
  'Easy to Start Action Plan',
];

export const TRUST_MAKERS = [
  {
    id: 1,
    image: '/assets/svgs/medically-backed.svg',
    title: 'about-trust-markers.medically-backed', //translatory
    rating: '100%',
  },
  {
    id: 2,
    image: '/assets/svgs/patients-treated.svg',
    title: 'about-trust-markers.patients-treated', //translatory
    rating: '30,000+',
  },
  {
    id: 3,
    image: '/assets/svgs/stethoscope-primary.svg',
    title: 'about-trust-markers.medical-expertise', //translatory
    rating: 'Top 1%',
  },
];

export const MEDIA_GRID = [
  {
    id: 1,
    image: '/assets/media-grid/economic-times.png',
    width: 284,
    height: 40,
  },
  {
    id: 2,
    image: '/assets/media-grid/money-control.png',
    width: 248,
    height: 56,
  },
  {
    id: 3,
    image: '/assets/media-grid/femina.svg',
    width: 140,
    height: 24,
  },
  {
    id: 4,
    image: '/assets/media-grid/indian-express.png',
    width: 276,
    height: 36,
  },
  {
    id: 5,
    image: '/assets/media-grid/abp.png',
    width: 116,
    height: 48,
  },
  {
    id: 6,
    image: '/assets/media-grid/times-of-india.png',
    width: 284,
    height: 20,
  },
  {
    id: 7,
    image: '/assets/media-grid/deccan-herald.png',
    width: 224,
    height: 64,
  },
];

export const SLOT_SELECTION = {
  SLOTS_LISTED: 'slots_listed',
  DEFAULT: 'default_slot',
  SELECTED: 'slot_selected',
  SLOT_CONFIRMED: 'slot_confirmed',
  PAYMENT_COMPLETED: 'payment_completed',
};

export const DEFAULT_LOCATION_CODE = 'ONLINE';
export const INSTANT_LOCATION_CODE = 'INSTANT';
export const PHONE_CALL_LOCATION_CODE = 'phone_call';

export enum ItemType {
  DRUG = 'drug',
  LAB = 'lab',
  COUNSELLING = 'counselling',
  CONSULTATION = 'consultation',
  PRESCRIPTION = 'prescription',
}

export enum ClinicFilters {
  'All' = 'All',
  'Female Doctors' = 'Female Doctors',
  'Male Doctors' = 'Male Doctors',
  'Nearest Doctors' = 'Nearest Doctors',
  'Highly Rated' = 'Highly Rated',
  'English Speaking' = 'English Speaking',
}

export enum ReportCategory {
  PRESCRIPTION = 'prescriptions',
  LABREPORT = 'lab-reports',
  PASTREPORTS = 'past-reports',
  ASSESSMENT_REPORT = 'assessment-reports',
  COUNSELLING_REPORT = 'counselling-reports',
}

export const navigationArray = [
  { NAME: 'DASHBOARD' },
  { NAME: 'APPOINTMENT' },
  { NAME: 'MEDICINES' },
  { NAME: 'LAB_TESTS' },
  { NAME: 'REPORT' },
];

export const PHONE_CALL_EXPERIMENT_PROVIDERS = [
  '712ddf53-5c87-4461-abee-5239b5da4eb2',
  'c2e5f76a-68ca-48b0-9b1a-07b049a4b805',
  'c3638406-1df4-49ba-820d-8eea502b66c0',
  '208b96ec-d923-450b-9653-56b8e01df246',
  '55676ffe-63a1-49aa-8c23-21176058ebee',
  '7e5c9901-ef91-47b9-9df8-6fccff4c8f43',
  '85f0670a-9618-495c-a1e9-cdfd8caf2750',
  '3add95bb-9765-4dac-be04-63d123e371f1',
  '61450a8b-c310-417f-a445-0a5834a68336',
];
